
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anxiety-test",
      function () {
        return require("private-next-pages/anxiety-test.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anxiety-test"])
      });
    }
  